// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "2a1aa7fa9eda0870b51b" + ".js";
};